export const BTN_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};

export const PAYMENT_ERRORS = {
  PAYMENT_FAILED: "There was a problem with your payment.",
  GENERIC_ERROR: "Something went wrong",
  REQUIRED_FIELD_ERROR: "REQUIRED_FIELD_ERROR",
};

export const PRODUCT_KIND = {
  MATIC_ROBOT: "MATIC_ROBOT",
  MATIC_ROBOT_SUBSCRIPTION: "MATIC_ROBOT_SUBSCRIPTION",
};

export const CUSTOM_ERROR_CODES = {
  EXPIRED_CART: "EXPIRED_CART",
  MISMATCHED_CART_PARAMETERS: "MISMATCHED_CART_PARAMETERS",
  CART_CONTENTS_UPDATED: "CART_CONTENTS_UPDATED",
};

export const PLAUSIBLE_EVENTS = {
  // for newsletter signup
  MAILING_SIGNUP: "Mailing Signup",
  // when they come to cart page
  ON_RESERVE: "On Reserve",
  // if name/email/address is put in and they abandon at this stage
  ON_RESERVE_ADDRESS: "On Reserve address",
  // when on the last payment (CC info page)
  ON_PAYMENT: "On payment",
  // when succeeded with payment page
  ON_PAYMENT_DONE: "Payment done",
  // when payment failed
  ON_PAYMENT_FAIL: "Payment failed",
};

export const formatNumber = (number) => {
  // Use Number.toFixed(2) to round to two decimal places.
  const roundedNumber = parseFloat(number).toFixed(2);

  // Use parseFloat to remove trailing zeros and convert back to a number.
  return parseFloat(roundedNumber);
};

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmail = (email) => {
  const isValid = EMAIL_REGEX.test(email);

  return isValid;
};
